export default __webpack_public_path__ + "static/2-15d4e5ca10158c960babc2e62930c40a.jpeg";